import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByCallback',
})
export class FilterByCallbackPipe implements PipeTransform {
  transform(data: any[], cb: (item: any) => {}): any {
    return data.filter(cb);
  }
}
